<template>
  <div>
    <BaseTop3
      v-if="question.top3"
      :items="itemsForInput"
      :value="value"
      :hint="$t('Order from 1 to 3')"
      @input="$emit('input', $event)"
    />
    <BaseRadioButtons
      v-else-if="!multiple"
      :items="question.answers"
      :value="value"
      @input="$emit('input', $event.value)"
    >
      <BaseRadioButton
        slot-scope="slotProps"
        :active="value === slotProps.item.value"
      >
        {{ slotProps.item.text }}
      </BaseRadioButton>
    </BaseRadioButtons>
    <BaseCheckbox
      v-else
      :value="value"
      :items="itemsForInput"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
import BaseRadioButtons from '../../components/BaseRadioButtons.vue';
import BaseRadioButton from '../../components/BaseRadioButton.vue';
import BaseCheckbox from '../../components/BaseCheckbox.vue';
import BaseTop3 from '../../components/BaseTop3.vue';

export default {
  name: 'Choice',
  components: {
    BaseRadioButtons,
    BaseRadioButton,
    BaseCheckbox,
    BaseTop3,
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
    value: {
      type: [Number, Array],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    itemsForInput() {
      return this.question.answers.map(answer => ({
        label: answer.text,
        value: answer.value,
      }));
    },
  },
};
</script>
